import React from 'react';
import CsvBulkUpload from './CsvBulkUpload';

const PostCarriers = () => <CsvBulkUpload role="carrier" title="Post Carriers" />;

export default PostCarriers;